import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  addWorkShift,
  clearError,
  clearSuccess,
} from "../../../../redux/Slices/authSlice";
import { toast } from "react-toastify";
import { FaArrowRight, FaPlus, FaTrash } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { applyFieldFilter } from "../../../../shared/utils.js/fieldValidation";

const AddShift = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation("global");
  const isRTL = i18n.language === "ar";
  const { isLoading, error, success } = useSelector(state => state.auth);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const lastErrorRef = useRef({ message: null, time: 0 });
  const lastSuccessRef = useRef({ message: null, time: 0 });
  const textAlign = isRTL ? "right" : "left";
  const dir = isRTL ? "rtl" : "ltr";

  useEffect(() => {
    if (success) {
      const now = Date.now();
      const last = lastSuccessRef.current;
      if (!last.message || last.message !== success || now - last.time > 2000) {
        toast.success(success, { rtl: isRTL });
        lastSuccessRef.current = { message: success, time: now };
        setTimeout(() => {
          dispatch(clearSuccess());
          navigate("/shifts");
        }, 1500);
      }
    }
  }, [success, dispatch, navigate]);

  useEffect(() => {
    if (error) {
      const now = Date.now();
      const last = lastErrorRef.current;
      if (!last.message || last.message !== error || now - last.time > 2000) {
        toast.error(error, { rtl: isRTL });
        lastErrorRef.current = { message: error, time: now };
      }
      const timer = setTimeout(() => {
        dispatch(clearError());
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [error, dispatch]);

  const [formData, setFormData] = useState({
    name_en: "",
    name_ar: "",
    details: [
      {
        day_of_week: "saturday",
        is_off_day: true,
        start_time: "",
        end_time: "",
      },
      {
        day_of_week: "sunday",
        is_off_day: false,
        start_time: "09:00",
        end_time: "17:00",
      },
      {
        day_of_week: "monday",
        is_off_day: false,
        start_time: "09:00",
        end_time: "17:00",
      },
      {
        day_of_week: "tuesday",
        is_off_day: false,
        start_time: "09:00",
        end_time: "17:00",
      },
      {
        day_of_week: "wednesday",
        is_off_day: false,
        start_time: "09:00",
        end_time: "17:00",
      },
      {
        day_of_week: "thursday",
        is_off_day: false,
        start_time: "09:00",
        end_time: "17:00",
      },
      { day_of_week: "friday", is_off_day: true, start_time: "", end_time: "" },
    ],
  });

  const daysOfWeek = [
    { key: "saturday", label: t("shifts.add.dayLabels.saturday") },
    { key: "sunday", label: t("shifts.add.dayLabels.sunday") },
    { key: "monday", label: t("shifts.add.dayLabels.monday") },
    { key: "tuesday", label: t("shifts.add.dayLabels.tuesday") },
    { key: "wednesday", label: t("shifts.add.dayLabels.wednesday") },
    { key: "thursday", label: t("shifts.add.dayLabels.thursday") },
    { key: "friday", label: t("shifts.add.dayLabels.friday") },
  ];

  const handleInputChange = e => {
    const { name, value, type, checked } = e.target;
    const finalValue =
      type === "checkbox" ? checked : applyFieldFilter(name, value);
    setFormData(prev => ({ ...prev, [name]: finalValue }));
  };

  const handleDayChange = (dayIndex, field, value) => {
    setFormData(prev => ({
      ...prev,
      details: prev.details.map((day, index) =>
        index === dayIndex ? { ...day, [field]: value } : day,
      ),
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsSubmitting(true);

    const invalidDays = formData.details.filter(
      day => !day.is_off_day && (!day.start_time || !day.end_time),
    );

    if (invalidDays.length > 0) {
      toast.error(t("shifts.add.validation.timeRequired"), { rtl: isRTL });
      setIsSubmitting(false);
      return;
    }

    try {
      await dispatch(addWorkShift(formData));
    } catch (err) {
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      style={{
        padding: "30px",
        backgroundColor: "#14263b",
        minHeight: "calc(100vh - 80px)",
        color: "white",
        direction: dir,
      }}
    >
      <div
        style={{
          marginBottom: "30px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h1
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            marginBottom: "20px",
            color: "white",
            margin: 0,
            textAlign,
          }}
        >
          {t("shifts.add.title")}
        </h1>
        <button
          onClick={() => navigate("/shifts")}
          style={{
            backgroundColor: "#666",
            color: "white",
            border: "none",
            padding: "10px 20px",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            flexDirection: isRTL ? "row" : "row-reverse",
          }}
        >
          <FaArrowRight />
          {t("shifts.add.back")}
        </button>
      </div>

      <form
        onSubmit={handleSubmit}
        style={{
          backgroundColor: "#1b3350",
          borderRadius: "12px",
          padding: "32px",
          border: "1px solid #333",
          maxWidth: "900px",
          margin: "0 auto",
        }}
      >
        {/* اسم الوردية - صفان جنب بعض */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "20px",
            marginBottom: "28px",
          }}
        >
          <div>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                color: "#ccc",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              {t("shifts.add.fields.nameAr")}{" "}
              <span style={{ color: "#AC2000" }}>*</span>
            </label>
            <input
              type="text"
              name="name_ar"
              value={formData.name_ar}
              onChange={handleInputChange}
              required
              placeholder={t("shifts.add.placeholders.nameAr")}
              style={{
                width: "100%",
                padding: "11px 14px",
                backgroundColor: "#1a1f2e",
                border: "1px solid #3a4050",
                borderRadius: "8px",
                color: "white",
                fontSize: "14px",
                direction: "rtl",
                textAlign: "right",
                boxSizing: "border-box",
              }}
            />
          </div>
          <div>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                color: "#ccc",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              {t("shifts.add.fields.nameEn")}{" "}
              <span style={{ color: "#AC2000" }}>*</span>
            </label>
            <input
              type="text"
              name="name_en"
              value={formData.name_en}
              onChange={handleInputChange}
              required
              placeholder={t("shifts.add.placeholders.nameEn")}
              style={{
                width: "100%",
                padding: "11px 14px",
                backgroundColor: "#1a1f2e",
                border: "1px solid #3a4050",
                borderRadius: "8px",
                color: "white",
                fontSize: "14px",
                direction: "ltr",
                textAlign: "left",
                boxSizing: "border-box",
              }}
            />
          </div>
        </div>

        {/* تفاصيل الأيام - compact table style */}
        <div style={{ marginBottom: "28px" }}>
          <h3
            style={{
              color: "white",
              marginBottom: "16px",
              fontSize: "16px",
              fontWeight: "bold",
              textAlign,
            }}
          >
            {t("shifts.add.fields.daysDetails")}
          </h3>

          {/* Header row */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "160px 140px 1fr 1fr",
              gap: "12px",
              padding: "10px 16px",
              backgroundColor: "#1a1f2e",
              borderRadius: "8px 8px 0 0",
              border: "1px solid #3a4050",
              borderBottom: "none",
            }}
          >
            <span
              style={{ color: "#aaa", fontSize: "13px", fontWeight: "600" }}
            >
              {t("shifts.add.dayFields.day", { defaultValue: "اليوم" })}
            </span>
            <span
              style={{ color: "#aaa", fontSize: "13px", fontWeight: "600" }}
            >
              {t("shifts.add.dayFields.offDay", { defaultValue: "إجازة" })}
            </span>
            <span
              style={{ color: "#aaa", fontSize: "13px", fontWeight: "600" }}
            >
              {t("shifts.add.dayFields.startTime", {
                defaultValue: "بداية الدوام",
              })}
            </span>
            <span
              style={{ color: "#aaa", fontSize: "13px", fontWeight: "600" }}
            >
              {t("shifts.add.dayFields.endTime", {
                defaultValue: "نهاية الدوام",
              })}
            </span>
          </div>

          {formData.details.map((day, index) => (
            <div
              key={day.day_of_week}
              style={{
                display: "grid",
                gridTemplateColumns: "160px 140px 1fr 1fr",
                gap: "12px",
                padding: "12px 16px",
                alignItems: "center",
                backgroundColor: index % 2 === 0 ? "#1a1f2e" : "#1e2535",
                border: "1px solid #3a4050",
                borderTop: "none",
                borderRadius:
                  index === formData.details.length - 1 ? "0 0 8px 8px" : "0",
              }}
            >
              <span
                style={{ color: "white", fontSize: "14px", fontWeight: "500" }}
              >
                {daysOfWeek.find(d => d.key === day.day_of_week)?.label}
              </span>

              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "white",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                <input
                  type="checkbox"
                  checked={day.is_off_day}
                  onChange={e =>
                    handleDayChange(index, "is_off_day", e.target.checked)
                  }
                  style={{
                    width: "16px",
                    height: "16px",
                    accentColor: "#AC2000",
                  }}
                />
                {day.is_off_day
                  ? t("shifts.add.dayFields.offDayYes", { defaultValue: "نعم" })
                  : t("shifts.add.dayFields.offDayNo", { defaultValue: "لا" })}
              </label>

              <input
                type="time"
                value={day.start_time}
                onChange={e =>
                  handleDayChange(index, "start_time", e.target.value)
                }
                disabled={day.is_off_day}
                required={!day.is_off_day}
                style={{
                  padding: "9px 12px",
                  backgroundColor: day.is_off_day ? "#111" : "#14263b",
                  border: "1px solid #3a4050",
                  borderRadius: "6px",
                  color: day.is_off_day ? "#555" : "white",
                  fontSize: "14px",
                  cursor: day.is_off_day ? "not-allowed" : "default",
                  width: "100%",
                  boxSizing: "border-box",
                }}
              />

              <input
                type="time"
                value={day.end_time}
                onChange={e =>
                  handleDayChange(index, "end_time", e.target.value)
                }
                disabled={day.is_off_day}
                required={!day.is_off_day}
                style={{
                  padding: "9px 12px",
                  backgroundColor: day.is_off_day ? "#111" : "#14263b",
                  border: "1px solid #3a4050",
                  borderRadius: "6px",
                  color: day.is_off_day ? "#555" : "white",
                  fontSize: "14px",
                  cursor: day.is_off_day ? "not-allowed" : "default",
                  width: "100%",
                  boxSizing: "border-box",
                }}
              />
            </div>
          ))}
        </div>

        {/* Buttons */}
        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: isRTL ? "flex-start" : "flex-end",
            borderTop: "1px solid #333",
            paddingTop: "24px",
          }}
        >
          <button
            type="button"
            onClick={() => navigate("/shifts")}
            style={{
              backgroundColor: "transparent",
              color: "#aaa",
              border: "1px solid #444",
              padding: "11px 28px",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "15px",
              fontWeight: "500",
            }}
          >
            {t("shifts.add.buttons.cancel")}
          </button>

          <button
            type="submit"
            disabled={isSubmitting}
            style={{
              backgroundColor: isSubmitting ? "#666" : "#AC2000",
              color: "white",
              border: "none",
              padding: "11px 28px",
              borderRadius: "8px",
              cursor: isSubmitting ? "not-allowed" : "pointer",
              fontSize: "15px",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              opacity: isSubmitting ? 0.7 : 1,
            }}
          >
            {isSubmitting ? (
              <>
                <div
                  style={{
                    width: "16px",
                    height: "16px",
                    border: "2px solid #fff",
                    borderTop: "2px solid transparent",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                  }}
                />
                {t("shifts.add.buttons.saving")}
              </>
            ) : (
              <>
                <FaPlus />
                {t("shifts.add.buttons.add")}
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddShift;
